<template>
<CRow  lang="ar" dir="rtl" >
  <CCol col="12" xl="12">
    <CCard  class="design">
      <CCardHeader>
         <CRow class="payment-row" >
        <CCol col="6" style="font-size: 25px;">عرض مدفوعات الطالب</CCol>
         <CCol col="6" style="font-size: 25px;">
         </CCol>
         </CRow>
      </CCardHeader>
      <CCardBody style="direction:rtl" >
        <div class="row" style="direction:rtl" id="printMe">
          <div class="col-md-12" style="text-align:center">
            <img src="../../assets/smart-logo.png" width="100px" height="100px">
          </div>
            <div class="col-md-6" style="direction:rtl">
              <h5>رقم الإيصال:{{payment.payment_number}}
              </h5>
                <table class="table table-bordered">
                  <tr>
                    <th>رقم الطالب</th>
                 <td>{{ payment.course_student.student_id}}</td>
                  </tr>
                  <tr>
                    <th>الإسم </th>
               <td>{{ payment.course_student.student.first_name}} {{ payment.course_student.student.last_name}}</td>
                  </tr>
                  <tr>
                    <th> اسم الدورة</th>
                 <td>{{ payment.course_student.course.name }}</td>
                  </tr>
                  <tr>
                    <th> تكلفة الدورة</th>
                 <td>{{ payment.cost }}<span>SDG</span></td>
                  </tr>
                  <tr>
                    <th>  تاريخ الدفع</th>
                  <td>{{newd }}</td>
                  </tr>
                  <tr>
                    <th>  رقم التسجيل</th>
                  <td>{{ registered_number}}</td>
                  </tr>
                </table>
            </div>
        </div>
      </CCardBody>
    </CCard>
    <CButton style="margin-left: 20px;"  color="primary" @click="print">طباعة</CButton>
        <CButton color="warning" @click="goBack">رجوع</CButton>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowPayment',
  data () {
    return {
      payment: [],
      output: null,
      newd: '',
      registered_number: null

    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}payment/${this.$route.params.id}`)
      .then((response) => {
        this.payment = response.data.data.payment
        this.registered_number = response.data.data.registered_number
        const date1 = this.payment.course_student.created_at
        this.newd = new Date(date1).toLocaleDateString()
      })
  },
  methods: {
    print () {
      this.$htmlToPaper('printMe',
       `@media print {
            ::v-deep .right-sidebar,
      ::v-deep header {
      display: block !important;
      background:red !important;
      }
      ::v-deep footer {
     display: none !important;
     }
                }`)
    },
    goBack () {
      this.studentsOpened ? this.$router.go(-1) : this.$router.push({ path: '/payments' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
  .payment-row{
    align-items: center;
  }
  .payment-row img{
    float: left;
  }

  #plugin{
      direction: rtl !important ;
    }
     .card-body {
      float:right !important ;
    direction: rtl  !important ;
     }
    .row{
        direction: rtl !important ;
      }
  .col-md-6 {
    float:right !important ;
    direction: rtl  !important ;
    }
    .table-bordered {
       float:right !important ;
    direction: rtl  !important ;
    }
    h5{
      font-weight: 700;
    }
    span{
      margin-left:3px
    }
</style>
